var map = {
	"./10-12-2020-v2/1024/img/Body_feathers_Normal.png": "3069",
	"./10-12-2020-v2/2048/img/Body_feathers_Normal.png": "0c46",
	"./10-12-2020-v2/512/img/Body_feathers_Normal.png": "02d1",
	"./10-12-2020-v3/1024/img/Body_feathers_Normal.png": "7e17",
	"./10-12-2020-v3/2048/img/Body_feathers_Normal.png": "c919",
	"./10-12-2020-v3/512/img/Body_feathers_Normal.png": "495d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "42f3";